export const strings = {
  en: {
    fundedTimes: ({ times = 0 }) => `Funded <b>${times}</b> ${times > 1 ? "times" : "time"} so far`,
    learnMore: () => `Learn more`,
    seeAll: () => `See All`,
  },
  fr: {
    fundedTimes: ({ times = 0 }) => `Financé <b>${times}</b> fois pour l'instant`,
    learnMore: () => `En savoir plus`,
    seeAll: () => `Voir tout`,
  },
};
